
import { useNavigate } from "react-router-dom";
import { FaArrowRight, FaArrowRightLong } from "react-icons/fa6";
import Colors from "../../utils/colors";


function HeaderProductList(){
let navigate = useNavigate();
return(
<div>
<div className="dropdown-menu-h" style={{borderColor:Colors.bg2}}>
                <div className="row no-margin">
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", height:"100%", padding:"3em 2.5em", backgroundColor:Colors.bg2}}>
                            <div className="bold h2" style={{paddingBottom:"1em"}}>Products</div>
                            <div style={{color:Colors.black1, fontSize:"17px", lineHeight:1.6}}>
                                MonyTrack Offers bespoke financial tools to ease financial operations for finance teams.
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", padding:"3em 2.5em", }}>
                            <div style={{color:Colors.gray, fontSize:"14px", marginBottom:'1em'}}>PRODUCTS</div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/accounts")}>
                                <div className="dot"></div> <div className="m-item">Accounts</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/accounts-360")}>
                                <div className="dot"></div> <div className="m-item">Accounts 360</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/business-payments")}>
                                <div className="dot"></div> <div className="m-item">Business Payments</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/global-payments")}>
                                <div className="dot"></div> <div className="m-item">Global Payments (CrossPay)</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/usd-cards")}>
                                <div className="dot"></div> <div className="m-item">Virtual USD Cards</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/invoicing")}>
                                <div className="dot"></div> <div className="m-item">Invoicing</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/vendor-management")}>
                                <div className="dot"></div> <div className="m-item">Vendor Management</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/approval-policies")}>
                                <div className="dot"></div> <div className="m-item">Approval Policies</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 no-padding">
                        <div style={{width:"100%", padding:"3em 2.5em", }}>
                            <div style={{color:Colors.gray, fontSize:"14px", marginBottom:'1em'}}>COMING SOON</div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/collection")}>
                                <div className="dot"></div> <div className="m-item">Collections</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/bulk-payments")}>
                                <div className="dot"></div> <div className="m-item">AI Bulk Payment</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/reconcile")}>
                                <div className="dot"></div> <div className="m-item">AI Automated Reconciliation</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/payroll")}>
                                <div className="dot"></div> <div className="m-item">Payroll</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                            <div className="flex-row m-items" onClick={()=>navigate("/business/products/treasury")}>
                                <div className="dot"></div> <div className="m-item">Treasury</div>
                                <div className="m-arrow"><FaArrowRightLong style={{marginTop:"4px"}}/></div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
</div>
)
}
export default HeaderProductList;